import Vue from 'vue';
import VueRouter, {NavigationGuard, NavigationGuardNext, Route, RouteConfig} from 'vue-router';
import MainPage from '../pages/MainPage/MainPage.vue';
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue';
import i18n from '../i18n';
import store from '../store';
import {MemberInfo, User} from '@/models';
import {alertService} from '@/services/alert.service';
import {hotelService} from '@/services/hotel.service';
import {decodeEmail} from '@/util/emailObfuscate';

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

//!!! 주의 !!!
// "/"를 제외한 모든 Vue 라우터 경로 시작은 /p/ 로 시작해야 브라우저에서 URL 직접 입력시 알맞게 동작하게 됨
// 다른 경로 또한 frontend 에서 처리되게 하고 싶으면 Spring쪽 코드 UiController.java 에서 포워딩 처리 추가 필요함!
const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: '',
    component: () => import(/* webpackChunkName: "" */ '../Index.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        component: MainPage,
      },
      // 테스트 시작
      // {
      //   path: '/p/personalAgree',
      //   name: 'PersonalAgree',
      //   component: () => import('../pages/Login/PersonalAgree.vue'),
      // },
      // 테스트 끝
      {
        path: '/p/login',
        name: 'Login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('../pages/Login/AuthLogin.vue'),
      },
      {
        path: '/p/AuthSignupPhone',
        name: 'AuthSignupPhone',
        component: () => import('../pages/Login/AuthSignupPhone.vue'),
      },
      {
        path: '/p/AuthSignupTerm',
        name: 'AuthSignupTerm',
        component: () => import('../pages/Login/AuthSignupTerm.vue'),
      },
      {
        path: '/p/AuthSignupFinish',
        name: 'AuthSignupFinish',
        component: () => import('../pages/Login/AuthSignupFinish.vue'),
      },
      {
        path: '/p/pg',
        name: 'PGTest',
        component: () => import('../pages/PGTest/PGTest.vue'),
      },
      {
        path: '/p/introduce',
        name: 'Introduce',
        component: () => import('../pages/About/IntroducePage.vue'),
      },
      {
        path: '/p/Photoview',
        name: 'Photoview',
        component: () => import('../pages/About/PhotoviewPage.vue'),
      },
      {
        path: '/p/Notice',
        name: 'Notice',
        component: () => import('../pages/About/NoticePage.vue'),
      },
      {
        path: '/p/NoticeRead/:boardArticleId',
        name: 'NoticeRead',
        component: () => import('../pages/About/NoticePageRead.vue'),
      },
      {
        path: '/p/Newsroom',
        name: 'Newsroom',
        component: () => import('../pages/NewsRoom/NewsroomPage.vue'),
      },
      {
        path: '/p/Newsroom/NewsroomDetail/:id',
        name: 'NewsroomDetail',
        component: () => import('../pages/NewsRoom/Components/NewsroomDetail.vue'),
      },
      {
        path: '/p/Review',
        name: 'Review',
        component: () => import('../pages/About/ReviewPage.vue'),
      },
      {
        path: '/p/Hotspring',
        name: 'Hotspring',
        component: () => import('../pages/About/HotspringPage.vue'),
      },
      {
        path: '/p/Presidentialsuite',
        name: 'Presidentialsuite',
        component: () => import('../pages/Room/PresidentialsuitePage.vue'),
      },
      {
        path: '/p/Royalsuitek',
        name: 'Royalsuitek',
        component: () => import('../pages/Room/RoyalsuitekPage.vue'),
      },
      {
        path: '/p/Royalsuitew',
        name: 'Royalsuitew',
        component: () => import('../pages/Room/RoyalsuitewPage.vue'),
      },
      {
        path: '/p/Deluxek',
        name: 'Deluxek',
        component: () => import('../pages/Room/DeluxekPage.vue'),
      },
      {
        path: '/p/Deluxew',
        name: 'Deluxew',
        component: () => import('../pages/Room/DeluxewPage.vue'),
      },
      /*{
        path: '/p/Gallerysoyi',
        name: 'Gallerysoyi',
        component: () => import('../pages/Facilities/GallerysoyPage.vue'),
      },*/
      // 23-05-17 현업요청으로 갤러리 소이 비활성화
      {
        path: '/p/Architecturalart',
        name: 'Architecturalart',
        component: () => import('../pages/Facilities/ArchitecturalartPage.vue'),
      },
      {
        path: '/p/Trekking',
        name: 'Trekking',
        component: () => import('../pages/Facilities/TrekkingPage.vue'),
      },
      {
        path: '/p/Restaurant',
        name: 'Restaurant',
        component: () => import('../pages/Dining/RestaurantPage.vue'),
      },
      {
        path: '/p/Wedding',
        name: 'Wedding',
        component: () => import('../pages/Wedding/WeddingPage.vue'),
      },
      {
        path: '/p/Reservinfo',
        name: 'Reservinfo',
        component: () => import('../pages/Reservation/ReservinfoPage.vue'),
      },
      {
        path: '/p/Realtimebooking2',
        name: 'Realtimebooking2',
        component: () => import('../pages/ReservePage/ReservePage.vue'),
        beforeEnter: checkTime,
      },
      {
        path: '/p/GuestReservResult',
        name: 'GuestReservResult',
        component: () => import('../pages/ReservePage/GuestReservResult.vue'),
      },
      {
        path: '/p/VipPkg',
        name: 'RealtimebookingGiftPkg',
        component: () => import('../pages/ReservePkg/ReservePkgVip.vue'),
      },
      // {
      //   path: '/p/PkgReserve',
      //   name: 'PkgReserve',
      //   component: () => import('../pages/ReservePkg/ReservePkgPage.vue'),
      // },
      // {
      //   path: '/p/RealtimebookingDining',
      //   name: 'RealtimebookingDining',
      //   component: () => import('../pages/ReserveDiningPage/ReserveDiningPage.vue'),
      // },
      {
        path: '/p/MemberReserv',
        name: 'MemberReserv',
        component: () => import('../pages/ReservePage/MemberReserv.vue'),
      },
      {
        path: '/p/ReceiptPkg/:id',
        name: 'ReceiptPkg',
        component: () => import('../pages/ReceiptPage/ReceiptPackagePage.vue'),
      },
      {
        path: '/p/ReceiptRoom',
        name: 'ReceiptRoom',
        component: () => import('../pages/ReceiptPage/ReceiptRoomPage.vue'),
      },
      {
        path: '/p/Hotelsouvenir',
        name: 'Hotelsouvenir',
        component: () => import('../pages/SpecialOffers/HotelsouvenirPage.vue'),
      },
      {
        path: '/p/Benefitinfo',
        name: 'Benefitinfo',
        component: () => import('../pages/SpecialOffers/BenefitinfoPage.vue'),
      },
      {
        path: '/p/MyPage',
        name: 'MyPage',
        component: () => import('../pages/Login/MyPage.vue'),
        meta: {authRequired: true},
      },
      {
        path: '/p/MyInfoManage',
        name: 'MyInfoManage',
        component: () => import('../pages/Login/MyInfoManage.vue'),
        meta: {authRequired: true},
      },
      {
        path: '/p/SignOut',
        name: 'SignOut',
        component: () => import('../pages/Login/SignOut.vue'),
        meta: {authRequired: true},
      },
      {
        path: '/p/FindId',
        name: 'FindId',
        component: () => import('../pages/Login/FindId.vue'),
      },
      {
        path: '/p/FindPw',
        name: 'FindPw',
        component: () => import('../pages/Login/FindPW.vue'),
      },
      // {
      //   path: '/p/Postcardbook',
      //   name: 'postcardbook',
      //   component: () => import('../pages/SpecialOffers/Components/hotelsouvenir/Postcardbook.vue'),
      // },
      // {
      //   path: '/p/Goldbookmark',
      //   name: 'goldbookmark',
      //   component: () => import('../pages/SpecialOffers/Components/hotelsouvenir/Goldbookmark.vue'),
      // },
      // {
      //   path: '/p/Artbuchae',
      //   name: 'artbuchae',
      //   component: () => import('../pages/SpecialOffers/Components/Artbuchae.vue'),
      // },
      {
        path: '/p/Tilemagnet',
        name: 'tilemagnet',
        component: () => import('../pages/SpecialOffers/Components/hotelsouvenir/Tilemagnet.vue'),
      },
      {
        path: '/p/Sionmug',
        name: 'sionmug',
        component: () => import('../pages/SpecialOffers/Components/hotelsouvenir/Sionmug.vue'),
      },
      {
        path: '/p/Diffuser',
        name: 'diffuser',
        component: () => import('../pages/SpecialOffers/Components/hotelsouvenir/Diffuser.vue'),
      },
      {
        path: '/p/Blanket',
        name: 'blanket',
        component: () => import('../pages/SpecialOffers/Components/hotelsouvenir/Blanket.vue'),
      },
      {
        path: '/p/Gown',
        name: 'gown',
        component: () => import('../pages/SpecialOffers/Components/hotelsouvenir/Gown.vue'),
      },
      {
        path: '/p/Facetowel',
        name: 'facetowel',
        component: () => import('../pages/SpecialOffers/Components/hotelsouvenir/Facetowel.vue'),
      },
      {
        path: '/p/Goose',
        name: 'goose',
        component: () => import('../pages/SpecialOffers/Components/hotelsouvenir/Goose.vue'),
      },
      {
        path: '/p/Cover',
        name: 'cover',
        component: () => import('../pages/SpecialOffers/Components/hotelsouvenir/Cover.vue'),
      },
      {
        path: '/p/Pillow',
        name: 'pillow',
        component: () => import('../pages/SpecialOffers/Components/hotelsouvenir/Pillow.vue'),
      },
      {
        path: '/p/Fathersgarden',
        name: 'Fathersgarden',
        component: () => import('../pages/SpecialOffers/Components/Fathersgarden.vue'),
      },
      {
        path: '/p/Rentalcars',
        name: 'Rentalcars',
        component: () => import('../pages/SpecialOffers/Components/Rentalcars.vue'),
      },
      /*{
        path: '/p/Podomuseum',
        name: 'Podomuseum',
        component: () => import('../pages/SpecialOffers/Components/Podomuseum.vue'),
      },*/
      // {
      //   path: '/p/Omorovicza',
      //   name: 'Omorovicza',
      //   component: () => import('../pages/SpecialOffers/Components/Omorovicza.vue'),
      // },
      {
        path: '/p/Dolcoriforest',
        name: 'Dolcoriforest',
        component: () => import('../pages/SpecialOffers/Components/Dolcoriforest.vue'),
      },
      {
        path: '/p/Jejubeer',
        name: 'Jejubeer',
        component: () => import('../pages/SpecialOffers/Components/Jejubeer.vue'),
      },
      {
        path: '/p/Jmgrandbleu',
        name: 'jmgrandbleu',
        component: () => import('../pages/SpecialOffers/Components/Jmgrandbleu.vue'),
      },
      {
        path: '/p/Aquaplanet',
        name: 'aquaplanet',
        component: () => import('../pages/SpecialOffers/Components/Aquaplanet.vue'),
      },
      {
        path: '/p/Figuremuseum',
        name: 'figuremuseum',
        component: () => import('../pages/SpecialOffers/Components/Figuremuseum.vue'),
      },
      /*{
        path: '/p/Sculpturepark',
        name: 'sculpturepark',
        component: () => import('../pages/SpecialOffers/Components/Sculpturepark.vue'),
      },*/
      /*{
        path: '/p/Dinosaurland',
        name: 'dinosaurland',
        component: () => import('../pages/SpecialOffers/Components/Dinosaurland.vue'),
      },*/
      {
        path: '/p/Submarine',
        name: 'submarine',
        component: () => import('../pages/SpecialOffers/Components/Submarine.vue'),
      },
      {
        path: '/p/Carmuseum',
        name: 'carmuseum',
        component: () => import('../pages/SpecialOffers/Components/Carmuseum.vue'),
      },
      {
        path: '/p/Bontemuseum',
        name: 'bontemuseum',
        component: () => import('../pages/SpecialOffers/Components/Bontemuseum.vue'),
      },
      {
        path: '/p/Hellokittyisland',
        name: 'hellokittyisland',
        component: () => import('../pages/SpecialOffers/Components/Hellokittyisland.vue'),
      },
      {
        path: '/p/Camelliahill',
        name: 'camelliahill',
        component: () => import('../pages/SpecialOffers/Components/Camelliahill.vue'),
      },
      {
        path: '/p/Wind1947',
        name: 'Wind1947',
        component: () => import('../pages/SpecialOffers/Components/Wind1947.vue'),
      },
      {
        path: '/p/Hueree',
        name: 'Hueree',
        component: () => import('../pages/SpecialOffers/Components/Hueree.vue'),
      },
      /*{
        path: '/p/Bunker',
        name: 'bunker',
        component: () => import('../pages/SpecialOffers/Components/Bunker.vue'),
      },*/
      {
        path: '/p/Cledepeaubeautespa',
        name: 'cledepeaubeautespa',
        component: () => import('../pages/SpecialOffers/Components/Cledepeaubeautespa.vue'),
      },
      {
        path: '/p/Phytsspa',
        name: 'phytsspa',
        component: () => import('../pages/SpecialOffers/Components/Phytsspa.vue'),
      },
      {
        path: '/p/Pacific',
        name: 'pacific',
        component: () => import('../pages/SpecialOffers/Components/Pacific.vue'),
      },
      {
        path: '/p/Artekidspark',
        name: 'Artekidspark',
        component: () => import('../pages/SpecialOffers/Components/Artekidspark.vue'),
      },
      {
        path: '/p/Soomdo',
        name: 'Soomdo',
        component: () => import('../pages/SpecialOffers/Components/Soomdo.vue'),
      },
      {
        path: '/p/Waterworld',
        name: 'Waterworld',
        component: () => import('../pages/SpecialOffers/Components/Waterworld.vue'),
      },
      {
        path: '/p/Lunafall',
        name: 'Lunafall',
        component: () => import('../pages/SpecialOffers/Components/Lunafall.vue'),
      },
      {
        path: '/p/Membership',
        name: 'membership',
        component: () => import('../pages/Membership/Membership.vue'),
      },

      {
        path: '/p/PkgList',
        name: 'PkgList',
        component: () => import('../pages/PkgList/PkgList.vue'),
      },
      {
        path: '/p/ItemDetail/:boardId/:id',
        name: 'ItemDetail',
        component: () => import('../pages/PkgList/Components/ItemDetail.vue'),
      },

      {
        path: '/p/DiningDetail/:id',
        name: 'DiningDetail',
        component: () => import('../pages/Dining/Components/DiningDetail.vue'),
      },

      {
        path: '/p/DiningPromotionDetail/:id',
        name: 'DiningPromotionDetail',
        component: () => import('../pages/Dining/Components/DiningPromotionDetail.vue'),
      },

      //  TEST
      {
        path: '/p/GenItemDetail',
        name: 'GenItemDetail',
        component: () => import('../pages/PkgList/Components/GenItemDetail.vue'),
      },
      {
        path: '/p/Introducepinx',
        name: 'Introducepinx',
        component: () => import('../pages/Footerlink/Introducepinx.vue'),
      },
      {
        path: '/p/Privacyinfo',
        name: 'Privacyinfo',
        component: () => import('../pages/Footerlink/Components/Privacyinfo.vue'),
      },
      {
        path: '/p/TOSgolfclub',
        name: 'TOSgolfclub',
        component: () => import('../pages/Footerlink/Components/TOSgolfclub.vue'),
      },
      {
        path: '/p/TOSpodohotel',
        name: 'TOSpodohotel',
        component: () => import('../pages/Footerlink/Components/TOSpodohotel.vue'),
      },
      {
        path: '/p/TOSannex',
        name: 'TOSannex',
        component: () => import('../pages/Footerlink/Components/TOSannex.vue'),
      },
      {
        path: '/p/Codeofethics',
        name: 'Codeofethics',
        component: () => import('../pages/Footerlink/Components/Codeofethics.vue'),
      },
      {
        path: '/p/Practiceguideline',
        name: 'Practiceguideline',
        component: () => import('../pages/Footerlink/Components/Practiceguideline.vue'),
      },
      {
        path: '/p/Consultation',
        name: 'Consultation',
        component: () => import('../pages/Footerlink/Components/Consultation.vue'),
      },
      {
        path: '/p/Introducepinxdetail',
        name: 'Introducepinxdetail',
        component: () => import('../pages/Footerlink/Components/Introducepinxdetail.vue'),
      },
      {
        path: '/p/Pinxhistory',
        name: 'Pinxhistory',
        component: () => import('../pages/Footerlink/Components/Pinxhistory.vue'),
      },
      {
        path: '/p/Pinxresortmoveinfo',
        name: 'Pinxresortmoveinfo',
        component: () => import('../pages/Footerlink/Components/Pinxresortmoveinfo.vue'),
      },
      {
        path: '/p/Resortmoveinfo',
        name: 'Resortmoveinfo',
        component: () => import('../pages/Footerlink/Components/Resortmoveinfo.vue'),
      },
      {
        path: '/p/Pinxpolicy/:idx',
        name: 'Pinxpolicy',
        component: () => import('../pages/Footerlink/Pinxpolicy.vue'),
      },
      {
        path: '/p/Direction',
        name: 'Direction',
        component: () => import('../pages/Footerlink/Direction.vue'),
      },
      {
        path: '/p/TOSpinx',
        name: 'TOSpinx',
        component: () => import('../pages/Footerlink/TOSpinx.vue'),
      },
      {
        path: '/p/Ethicalmanagement',
        name: 'Ethicalmanagement',
        component: () => import('../pages/Footerlink/Ethicalmanagement.vue'),
      },
      {
        path: '/p/Rejectionemail',
        name: 'Rejectionemail',
        component: () => import('../pages/Footerlink/Rejectionemail.vue'),
      },
      {
        path: '/p/EventMain',
        name: 'EventMain',
        component: () => import('../pages/Footerlink/EventMain.vue'),
      },
      {
        path: '/p/VipPackageMain',
        name: 'VipPackageMain',
        component: () => import('../pages/Footerlink/VipPackageMain.vue'),
      },
      {
        path: '/p/QnaMain',
        name: 'QnaMain',
        component: () => import('../pages/Footerlink/QnaMain.vue'),
      },
      {
        path: '/p/Marketingaffiliate',
        name: 'Marketingaffiliate',
        component: () => import('../pages/Footerlink/Marketingaffiliate.vue'),
      },
      {
        path: '/p/Marketingcontact',
        name: 'Marketingcontact',
        component: () => import('../pages/Footerlink/Marketingcontact.vue'),
      },
      {
        path: '/p/MarketingMain',
        name: 'MarketingMain',
        component: () => import('../pages/Footerlink/MarketingMain.vue'),
      },
      {
        path: '/p/WeddingMain',
        name: 'WeddingMain',
        component: () => import('../pages/Wedding/WeddingMain.vue'),
      },
      {
        path: '/p/PersonalAgree',
        name: 'PersonalAgree',
        component: () => import('../pages/Login/PersonalAgree.vue'),
      },
      {
        path: 'p/trans',
        name: 'Trams',
        component: () => import('../pages/Trans/Trans.vue'),
      },
      // {
      //   path: '/p/Mall',
      //   name: 'Mall',
      //   component: () => import('../pages/mall/mall.vue'),
      // },
      {
        path: '/noHeader',
        name: '',
        component: () => import(/* webpackChunkName: "" */ '../components/IndexNoHeader.vue'),
        children: [
          {
            path: 'p/bizSirenCallBackPhone',
            name: 'BizSirenCallBackPhone',
            component: () => import('../pages/Login/BizSirenCallBackPhone.vue'),
          },
          {
            path: 'p/bizSirenCallBackIpin',
            name: 'bizSirenCallBackIpin',
            component: () => import('../pages/Login/BizSirenCallBackIpin.vue'),
          },
          {
            path: 'p/login/navercallback',
            name: 'NaverCallBack',
            component: () => import('../pages/Login/NaverCallBack.vue'),
          },
          {
            path: 'p/login/kakaocallback',
            name: 'KakaoCallBack',
            component: () => import('../pages/Login/KakaoCallBack.vue'),
          },
        ],
      },
      // WARN: 아래 내용 절대 옮기지 마시오! //404 Notfound 시 홈으로 리다이렉팅
      {
        path: '*',
        redirect: '/',
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return {x: 0, y: 0};
  },
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(function (to, from, next) {
  // to: 이동할 url에 해당하는 라우팅 객체
  const isLoggedIn = store.getters['Auth/isLoggedIn'];
  const loginUser = store.getters['Auth/loginUser'];
  if (
    to.matched.some(function (routeInfo) {
      return routeInfo.meta.authRequired;
    })
  ) {
    if (!isLoggedIn) {
      // 이동할 페이지에 인증 정보가 필요하면 경고 창을 띄우고 페이지 전환은 하지 않음
      alert('로그인이 필요합니다!');
      next({name: 'Login', params: {returnUrl: to.path}});
      return;
    }
  }

  if (isLoggedIn) {
    const pathLower = to.path.toLowerCase();
    const checkPath = '/p/personalagree';
    if (
      loginUser.opinionYn === 'N' ||
      loginUser.prsinClctn01 === 'N' ||
      loginUser.prsinClctn02 === 'N' ||
      (isMyMemTypeCorpMember() && loginUser.prsinClctn03 === 'N')
    ) {
      ///p/PersonalAgree 페이지로만 이동가능
      if (pathLower === checkPath) {
        next();
      } else {
        next({name: 'PersonalAgree', params: {step: '1'}});
      }
      return;
    } else {
      // 마케팅 동의 여부 확인
      if (loginUser.marketingChk === 'Y') {
        if (pathLower === checkPath) {
          next();
        } else {
          next({name: 'PersonalAgree', params: {step: '3'}});
        }
        return;
      }
      // 위 경우가 아닌경우 /p/personalagree 방문시 홈으로 리다이렉트
      console.log('pathLower:', pathLower, pathLower === '/p/personalagree');
      if (pathLower === checkPath) {
        next({name: 'Home'});
        return;
      }
    }
  }

  const currentLocale: 'ko' | 'en' = i18n.locale as 'ko' | 'en';

  console.log(currentLocale);

  if (!currentLocale) {
    console.error('i18n locale is undefined');
    next('/');
    return;
  }

  const disabledPaths: Record<'ko' | 'en', string[]> = {
    ko: ['/p/ReceiptRoom', '/p/ReceiptPkg'],
    en: [],
  };

  if (disabledPaths[currentLocale]?.includes(to.path)) {
    next('/');
  } else {
    next();
  }
});

function isMyMemTypeCorpMember() {
  const selectedMember = store.getters['Auth/selectedMember'];
  if (!selectedMember) return false;
  if (
    selectedMember.memType === '001' ||
    selectedMember.memType === '002' ||
    selectedMember.memType === '003' ||
    selectedMember.memType === '004' ||
    selectedMember.memType === '005' ||
    selectedMember.memType === '006' ||
    selectedMember.memType === '007'
  ) {
    return true;
  }
  return false;
}

async function checkTime(to: Route, from: Route, next: NavigationGuardNext<Vue>): Promise<any> {
  const memInfo: MemberInfo = store.getters['Auth/selectedMember'];
  //console.log('checkTime');
  // 기본적으로 법인,일반,골드 회원 이외의 회원은 예약 못함.
  let canEnter = false;
  let extrMsg = '';
  if (memInfo && memInfo.memType === '006' && memInfo.guestType === '001') {
    //법인패키지 PMS 예약가능여부 확인
    const isBupinEabled = await hotelService.isBupinEnable(memInfo.memNo);
    if (!isBupinEabled) {
      //법인패키지 일 경우 목요일 09~17시까지만 접수 가능
      canEnter = false;
      extrMsg = `핀크스 골프PKG 혜택 확정 후 예약 가능합니다.\n예약 문의 등 상담을 원하실 경우, 예약실로 문의 부탁드립니다.\n\n[핀크스 예약실]\n${decodeEmail(
        'bookingKr',
      )}\n064-792-8000`;
    } else {
      // 비 로그인 상태는 beforeResolve() 에서 로그인 페이지로 안내 되도록 진행시킴
      next();
    }

    //디버깅용
    //canEnter = true;
    if (!canEnter) {
      if (extrMsg.trim() !== '') {
        alertService.showAlert(extrMsg).then(res => {
          next({name: 'Home'});
        });
      }
    } else next();
  } else next();
}

export default router;
